<template>
  <div>
    <div
      v-for="(item, index) in items"
      :key="index"
      :class="{'border-b': index !== (items.length - 1)}"
      class="border-shadow-color py-4 cursor-pointer flex"
      @click="toggleValue(item.value)"
    >
      <div
        :class="{'border': !active(item), 'bg-orange': active(item)}"
        class="checkbox mr-2 border-custom-color rounded-sm mt-1 md:mt-0
        flex items-center justify-center text-white"
      >
        <Tick v-if="active(item)" />
      </div>
      <BaseParagraph>
        <span
          :class="{'text-grey': !active(item), 'text-black': active(item)}"
        >
          {{ item.label }}
        </span>
      </BaseParagraph>
    </div>
  </div>
</template>

<script>
import { includes, without, concat } from 'lodash';
import BaseGreyText from './BaseGreyText.vue';
import BaseParagraph from './BaseParagraph.vue';
import Tick from './icons/Tick.vue';

export default {
  name: 'BaseCheckbox',
  components: {
    BaseGreyText,
    BaseParagraph,
    Tick,
  },
  props: {
    value: {
      type: Array,
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  methods: {
    active(item) {
      if (!this.value) {
        return false;
      }
      return includes(this.value, item.value);
    },
    toggleValue(value) {
      let result;
      if (this.value && includes(this.value, value)) {
        result = without(this.value, value);
      } else if (this.value) {
        result = concat(this.value, [value]);
      } else {
        result = [value];
      }
      this.$emit('input', result);
    },
  },
};
</script>

<style lang="scss" scoped>
.border-custom-color {
  border-color: rgba(0,0,0,0.4);
}
.checkbox {
  min-height: 18px;
  min-width: 18px;
  height: 18px;
  width: 18px;
}
</style>
